import React, { Component } from 'react'

class SchedulingCard extends Component {
    render() {
        const { id, status_code, toggle, periodical_name, date, month_year, users, is_charged, facility_name } = this.props;

        const statusMap = { 1: 'unassigned', 2: 'assigned', 3: 'inprogress', 4: 'abandoned', 5: 'completed' };
        const statusClass = statusMap[status_code] || '';
        const isClickable = status_code === 1 || status_code === 2;

        return (
            <div
                className={`sched-item-card${statusClass ? ` sched-item-card--${statusClass}` : ''}`}
                id={id}
                onClick={isClickable ? () => toggle(id) : undefined}
            >
                {month_year && (
                    <span className="sched-item-card__month-tag">{month_year}</span>
                )}
                <p className="sched-item-card__title">{periodical_name}</p>
                <p className="sched-item-card__meta">
                    {date}{facility_name ? ` \u2022 ${facility_name}` : ''}
                </p>
                {/* {(users.length > 0 || is_charged) && (
                    <div className="sched-item-card__footer">
                        {users.map(x =>
                            <span className="sched-avatar" key={x.user_id || x.id}>
                                {x.user_name.slice(0, 1)}
                            </span>
                        )}
                        {is_charged && <span className="sched-charge-badge">$</span>}
                    </div>
                )} */}
            </div>
        );
    }
}

SchedulingCard.defaultProps = { users: [], is_charged: false, freq: "", facility_name: "" };

export default SchedulingCard;



// WEBPACK FOOTER //
// ./src/shared/components/Cards/scheduling_card.js